import { useParams, Link } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import ammy from "./VideoPage.module.css";
import axios from "axios";

export default function VideoPage() {
  const sliderRef = useRef(null);

  const [videos, setVideos] = useState([]);
  const [related, setRelated] = useState([]);
  const [relateCategoryVideo, setRelateCategoryVideo] = useState([]);

  const { id } = useParams();
  const videoId = Number(id); // FIX: id is string

  // Fetch API Data
  const fetchVideos = async () => {
    try {
      const response = await axios.get(
        "https://ke-kiddzmania.rashigames.com/api/fetch-product"
      );

      const videoList = response.data.videos || [];

      setVideos(videoList);

      // Current video
      const current = videoList.filter((v) => v.id === videoId);
      setRelated(current);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [id]);

  // Related Videos (same category)
  useEffect(() => {
    if (related.length && videos.length) {
      setRelateCategoryVideo(
        videos.filter(
          (v) =>
            v.category_id === related[0].category_id && v.id !== related[0].id
        )
      );
    }
  }, [related, videos, id]);

  return (
    <div className={ammy.videoPage}>
      <Link to="/" className={ammy.backBtn}>
        ← Back to Home
      </Link>

      <div className={ammy.videoLayout}>
        {/* MAIN VIDEO */}
        <div className={ammy.mainVideo}>
          <ReactPlayer
            src={related[0]?.video_src}
            controls
            width="100%"
            height="400px"
           
            className={ammy.player}
          />
          <h2 className={ammy.videoTitle}>{related[0]?.name || "Video"}</h2>
        </div>

        {/* RELATED VIDEOS */}
        <div className={ammy.relatedSection}>
          <h3>Related Videos</h3>

          {relateCategoryVideo.map((video) => (
            <div key={video.id} className={ammy.relatedCard}>
              <ReactPlayer
                src={video.video_src}
                controls
                width="100%"
                height="120px"
              />
              <h4>{video.name}</h4>

              <Link to={`/video/${video.id}`}>
                <button className={ammy.watchBtn}>Watch</button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
